import $ from 'jquery';
import select2 from 'select2';
import 'jquery.cookie';

import { templateNameEquals } from "@savchukoleksii/shopify-template-checker";

select2($);

$(document).ready(function () {
    try {
        // Holiday Rollerball box sku magic
        function rollerCartMgc() {
            if ($("span[rv-text='item.product_title']:contains('Rollerball Duo & Discovery Set')").length > 0 && ($("div.item[variant-id='32921828786266']").length < 1)) {
                window.CartJS.addItem('32921828786266');
            }
            if ($("span[rv-text='item.product_title']:contains('Rollerball Duo & Discovery Set')").length > 0 && ($("div.item[variant-id='32921828786266']").length == 1)) {
                window.CartJS.cart.item_count = CartJS.cart.item_count - 1;
            }
            if ($("span[rv-text='item.product_title']:contains('Rollerball Duo & Discovery Set')").length < 1 && ($("div.item[variant-id='32921828786266']").length > 0)) {
                window.CartJS.removeItemById('32921828786266');
            }
        }

        $(document).on('cart.requestComplete', function (event, cart) {
            rollerCartMgc()
        });
    } catch (error) {
        console.error('Holiday Rollerball box sku magic:', error);
    }

    $(function () {
        var height = $('.is-atc.form-atc').height();
        var heightMargin = parseInt(height, 10) + 70;
        $('.is-atc.form-atc').css({'top': 'calc(100vh - ' + heightMargin + 'px)'});
    });

    $('.select2').select2({
        theme: "flat",
        minimumResultsForSearch: -1,
        width: "100%"
    });

    $("select.single-option-selector").on('change', function () {
        var newPrice = $(this).find("option:selected").attr('price');
        $(this).closest('.split-atc').find('.split-button .bs-price').html(newPrice);
    });

    // collection page variant image switch
    $("select.single-option-selector").on('change', function () {
        var newIMG = $(this).find("option:selected").attr('data-image');
        $(this).closest('.prod-card').find('a').css("background-image", "url(" + newIMG + ")");
    });

    // category hover magic
    $('.prod-card').hover(
        function () {
            $(this).closest('.prod-card').toggleClass('hover');
        }
    );

    $('.prod-card .split-atc, .prod-card .form-holder, .prod-card div.button').hover(
        function () {
            $(this).closest('.prod-card').toggleClass('hover');
        }
    );

    /* Currency switcher */
    $('.shopify-currency-form select').on('change', function () {
        $(this)
            .parents('form')
            .submit();
    });

    /* Popup index cookie and close button */
    $(".close, .popup-overlay").on("click", function () {
        $(".popup-overlay").addClass("hidden");
    });


// Show pop-up only once per day per user
    if (!$.cookie("popupshown")) {
        $(".popup-overlay, .popup-content").removeClass("cookie-hide");
        $.cookie('popupshown', true, {expires: 1, path: '/'});
    }

    /* Sets page animation */

    var timeDif = 0;
    jQuery($('.title-text').get()).each(function () {
        var $el = $(this);
        setTimeout(function () {
            $el.addClass('slide-in');
        }, 400 * timeDif);
        timeDif++;
    });

    /* Product page variant image loader */
    $(function () {
        let inverseVal = "";
        let variantCombo = "";

        $('select[id^="SingleOptionSelector"]').change(function () {
            inverseVal = "";
            if ($(this).attr("id") == "SingleOptionSelector-0") {
                inverseVal = $('#SingleOptionSelector-1').val();
            } else if ($(this).attr("id") == "SingleOptionSelector-1") {
                inverseVal = $('#SingleOptionSelector-0').val();
            }
            if (inverseVal == "") return;
            variantCombo = $(this).val() + ' / ' + inverseVal;
            $('#option-nojs option').each(function () {
                if ($(this).text().includes(variantCombo)) {
                    $('.featured-image img#featured-source').hide();
                    $('.ajaxloader').show();
                    $('.featured-image img#featured-source').attr("src", $(this).attr("data-image")).load(function () {
                        $('.ajaxloader').fadeOut();
                        $('.featured-image img#featured-source').fadeIn(250);
                    });
                    $('.featured-image source').attr("srcset", $(this).attr("data-image"));
                    $('.mobile-product-img img#featured-source-mobile').hide();
                    $('.mobile-product-img .ajaxloader').show();
                    $('.mobile-product-img img#featured-source-mobile').attr("src", $(this).attr("data-image")).load(function () {
                        $('.mobile-product-img .ajaxloader').fadeOut();
                        $('.mobile-product-img img#featured-source-mobile').fadeIn(250);
                    });
                    $('.mobile-product-img source').attr("srcset", $(this).attr("data-image"));
                }
            });
        });
    });

    if (templateNameEquals('index')) {
        // homepage hero top margin
        if (!$.cookie("hideannounce")) {
            $(".home__hero").css('margin-top', '30px');
        }
    }

    if (templateNameEquals('product')) {
        var height = $('.is-atc.form-atc').height();
        var heightMargin = parseInt(height, 10) + 70;
        $('.is-atc.form-atc').css({'top': 'calc(100vh - ' + heightMargin + 'px)'});

        // product ingredients overlay toggle
        $(".ingredients__overlay__trigger").click(function () {
            $("div.ingredients").addClass("is-open");
            $("body").addClass("no-scroll");
        });

        $(".ingredients__overlay__x").click(function () {
            $("div.ingredients").removeClass("is-open");
            $("body").removeClass("no-scroll");
        });
    }

    if ([
        templateNameEquals('collection'),
        templateNameEquals('index'),
        templateNameEquals('product')
    ].includes(true)) {
        function stockCheck() {
            if ($(this).find("option:selected").attr('available') == 'false') {
                $(this).closest('.split-atc').find('.split-button button.button').css('display', 'none');
                $(this).closest('.split-atc').find('.split-button .button.out-of-stock-btn').css('display', 'block');
                $('.out-of-stock-msg').css('display', 'block');

            } else {
                $(this).closest('.split-atc').find('.split-button button.button').css('display', 'block');
                $(this).closest('.split-atc').find('.split-button .button.out-of-stock-btn').css('display', 'none');
            }
        }

        $(function () {
            $("select.single-option-selector").on('change', function () {
                if ($(this).find("option:selected").attr('available') == 'false') {
                    $(this).closest('.split-atc').find('.split-button button.button').css('display', 'none');
                    $(this).closest('.split-atc').find('.split-button .button.out-of-stock-btn').css('display', 'block');
                    $('.out-of-stock-msg').slideDown();
                } else {
                    $(this).closest('.split-atc').find('.split-button button.button').css('display', 'block');
                    $(this).closest('.split-atc').find('.split-button .button.out-of-stock-btn').css('display', 'none');
                    $('.out-of-stock-msg').slideUp();
                }
            });
        });
    }

    if (!window.__st.cid) {
        $(".close-news, .no-thanks").on("click", function () {
            $(".newsletter-popup-overlay").addClass("hidden");
        });

        $(function () {
            if (!$.cookie("newspopupshown")) {
                $(".newsletter-popup-overlay").removeClass("cookie-hide");
            }
            $.cookie('newspopupshown', true, {expires: 30, path: '/'});
        });
    }
});
